import styled from '@xstyled/styled-components'

export const recorderWaveformMaxWidth = 1280

export const StyledRecorderWaveform = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  maxWidth: recorderWaveformMaxWidth
})

export const StyledRecorderAudioWaveformWrapper = styled.div({
  backgroundColor: 'white',
  zIndex: 1,
  paddingLeft: 8
})

const lineHeight = 4

export const StyledRecorderWaveformLine = styled.div({
  position: 'absolute',
  width: '100%',
  height: lineHeight,
  borderRadius: lineHeight + 1,
  backgroundColor: 'grey.l3'
})
